// extracted by mini-css-extract-plugin
export default {"card":"C4BSHsnP","image":"BMijW56Y","content":"jN8_F6nR","title":"OoOaE8Rg"};